import { render, staticRenderFns } from "./ManagerDetail.vue?vue&type=template&id=e6cbe662&scoped=true"
import script from "./ManagerDetail.vue?vue&type=script&lang=js"
export * from "./ManagerDetail.vue?vue&type=script&lang=js"
import style0 from "./ManagerDetail.vue?vue&type=style&index=0&id=e6cbe662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cbe662",
  null
  
)

export default component.exports